<!-- TOKENIZED -->
@if (tokenized) {
  <div fxFlex fxLayoutAlign="center center">
    <button style="width: 220px" mat-stroked-button (click)="onCreateToken()" matTooltip="{{'general.createToken' | transloco}}">
      <mat-icon class="iconLarger">power</mat-icon>
      {{ 'general.connectToAccount2' | transloco }}
    </button>
  </div>
}

@if (socialized) {
  <div class="fade-in">
    <app-scene-social-token></app-scene-social-token>
    <br/>
    <br/>
  </div>
}

<!-- PLAYER -->
<div>
  @switch (this.sceneItem?.$?.player) {
    <!-- <div *ngSwitchCase="blockLabelRecords?.JSON_VIEWER.id">
  </div>
  <div *ngSwitchCase="blockLabelRecords?.JSON_PLAYER.id">
  </div> -->
  @case (blockLabelRecords?.WEATHER.id) {
    <div>
    </div>
  }
  @case (blockLabelRecords?.SPREADSHEET.id) {
    <div>
    </div>
  }
  @case (blockLabelRecords?.STOCKS.id) {
    <div>
      <button (click)="appendDefaultStocks()" mat-raised-button>
        <mat-icon>refresh</mat-icon>
        {{ 'general.resetStocksSymbols' | transloco }}
      </button>
      <br/>
      <br/>
      <span style="position: relative; left: -30px;">{{ 'general.totalStockSymbols' | transloco }}: [ {{ totalStockSymbols }} ]</span>
      <br/>
      <br/>
    </div>
  }
  @case (blockLabelRecords?.CALENDAR.id) {
    <div>
    </div>
  }
  @case (blockLabelRecords?.CATALOG.id) {
    <div>
      <app-category-tree
        [createMode]="false"
        [expandAll]="true"
        [setCategoryValues]="categoryTreeItems"
        (updateTreeSelection)="onUpdateTreeSelection($event)">
      </app-category-tree>
    </div>
  }
  @default {
    <div>
    </div>
  }
}
</div>

<!-- SCENE -->
<div fxFlex fxLayoutAlign="space-between center">
  <mat-form-field style="flex: 1; margin-right: 10px;">
    <mat-label>{{ 'general.selectScene' | transloco }}</mat-label>
    <mat-select [(value)]="assignedScene" (selectionChange)="onSceneChange($event)">
      @for (scene of this.scenesSimple; track scene) {
        <mat-option [value]="scene">
          {{ scene.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <button color="warn" mat-icon-button class="mini-button" (click)="openSceneAssignmentDialog()" matTooltip="{{'general.importScene' | transloco}}">
    <mat-icon>star</mat-icon>
  </button>
  <button mat-icon-button class="mini-button" (click)="openSceneEditor()" matTooltip="{{'general.jumpToScene' | transloco}}">
    <mat-icon>link</mat-icon>
  </button>
</div>

<!-- DYNAMIC -->
@if (dynamicsInitialized) {
  <div>
    <dynamic-form #dynamicFormComponent
      [fields]="uiConfigInit"
      (submit)="submit($event)">
    </dynamic-form>
  </div>
}


@if (tokenized) {
  <div fxFlex fxLayoutAlign="space-between center">
    <mat-form-field style="flex: 1">
      <!-- <mat-select [(value)]="selectedTokenValue" (selectionChange)="onTokenIdBindingChange($event)">
      <mat-option *ngFor="let tokenItem of tokenItems" [value]="tokenItem">
        {{tokenItem.name}}
      </mat-option>
    </mat-select> -->
    <mat-label>{{ tokenFieldName }}</mat-label>
    <input inputrestriction="basic1" matInput placeholder="" [value]="selectedTokenValue.id" readonly>
  </mat-form-field>
  <button mat-icon-button class="mini-button" (click)="showTokenListTreeview()" matTooltip="{{'general.refresh' | transloco}}">
    <mat-icon>folder_open</mat-icon>
  </button>
  <!--        <button mat-icon-button (click)="onCreateToken()" matTooltip="{{'general.createToken' | transloco}}">-->
  <!--            <mat-icon>power</mat-icon>-->
<!--        </button>-->
</div>
}
<br/>
<div>
  @switch (this.sceneItem?.$?.player) {
    @case (blockLabelRecords?.CATALOG_ITEM?.id) {
      <div>
        <hr/>
        <app-font-selector (onChange)="onFontChanged($event, '', 'CATALOG_ITEM')" [setConfig]="{i_config: sceneItem}"></app-font-selector>
        <hr/>
        <br>
          <br>
            <br>
            </div>
          }
          @default {
            <div>
            </div>
          }
        }
      </div>



